import { memo } from 'react'

import { Text } from '@cash-me/react-components'
import { Autoplay } from 'swiper/modules'

import { Carousel } from 'components/carousel'
import { Grid, Col } from 'components/grid'
import { SectionLabel } from 'components/section-label'
import { theme } from 'styles/theme'

import { statistics } from './data'
import * as S from './styles'

const MARQUEE_REPEAT = 4
const marqueeStats = Array.from({ length: MARQUEE_REPEAT }, (_, repeat) =>
  statistics.map(stat => ({ ...stat, key: `${stat.value}-${repeat}`, ariaHidden: repeat > 0 }))
).flat()

const Statistics = memo(() => (
  <S.Statistics>
    <Grid col={{ phone: 1, tablet: 1, desktop: 1 }}>
      <Col>
        <S.Content>
          <SectionLabel size="body1" weight="bold" color="white" barColor={theme.colors['cashme-blue-neon']}>
            CashMe em números
          </SectionLabel>

          <S.Marquee>
            <Carousel
              swiperOptions={{
                modules: [Autoplay],
                loop: true,
                slidesPerView: 'auto',
                spaceBetween: 0,
                autoplay: { delay: 0, disableOnInteraction: false },
                speed: 3500,
                allowTouchMove: false,
                a11y: { enabled: false }
              }}
            >
              {marqueeStats.map(({ value, label, key, ariaHidden }) => (
                <S.Item key={key} aria-hidden={ariaHidden || undefined}>
                  <Text size="heading3" weight="medium" color="var(--colors-neutral-text-contrast-default)">
                    {value}
                  </Text>
                  <Text size="caption" color="#ffffffcc">
                    {label}
                  </Text>
                </S.Item>
              ))}
            </Carousel>
          </S.Marquee>
        </S.Content>
      </Col>
    </Grid>
  </S.Statistics>
))

Statistics.displayName = 'Statistics'

export default Statistics
